const en = {
  here_today_coupon: "Here’s today’s coupon",
  checkbox: {
    required: "Required",
    optional: "Optional",
  },
  btn: {
    refresh: "Refresh",
    next: "Next",
    back: "Back",
    ok: "OK",
    send_response: "Send response",
    register: "Register",
    delete: "Delete",
    answer: "Answer"
  },
  calender: {
    incorrect_date_format: "Incorrect date format",
    cannot_set_date_before_min_year: "Cannot set date before {{minYear}}",
    today: "Today",
  },
  sample_coupon: "Sample coupon",
  use_coupon: "Use coupon",
  terms_and_conditions: "Terms & Conditions",
  only_half_width_numeric_characters: "*only half-width numeric characters",
  only_half_width_alphanumeric_characters: "*only half-width alphanumeric characters",
  enter_a_7_digit_number_without_hyphens: "Enter a 7 digit number without hyphens",
  seven_digit_number_no_hyphens: '7 digit number (no hyphens)'
};
export default en;
